import Promo from '../../modules/Promo/Promo';

function PagePromo() {
    return <Promo />;
}

export default PagePromo;
